<template>
    <div class="confirm-overlay">
        <div class="confirm-dialogue">
            <div class="confirm-dialogue-inner">
                <div class="confirm-message">
                    <h3>Why you been acting so messed up towards me?</h3>
                </div>
                <div class="confirm-buttons">
                    <button class="cancel" title="Nevermind" @click="hideConfirmDialogue">Nevermind</button>
                    <button class="confirm" title="Delete Palette" @click="$emit('delete'); hideConfirmDialogue(); hideOptions();">Delete</button>
                </div>
            </div>
            <img class="confirm-image" :src="deleteImage" alt="">
        </div>
    </div>
</template>

<script>
    import Image        from "../../../Lib/Objects/Image";
    import { TweenMax } from "gsap";

    export default {
    name: "confirm-dialogue",
    props: [ 'hide-options', ],
    
    data() {
        return {
            deleteImage: new Image("hansel-messed-up.png").getPath(),
        }
    },

    methods: {
        showConfirmDialogue() {
            TweenMax.fromTo(".confirm-overlay", 0.5, {
                autoAlpha: 0,
                ease: Power4.ease,
            },{
                autoAlpha: 1,
            });
            this.showConfirmInner();
        },

        showConfirmInner() {
            TweenMax.fromTo(".confirm-dialogue", 0.5, {
                autoAlpha: 0,
                scale: 1.15,
                ease: Power3.ease,
            }, {
                delay: 0.25,
                autoAlpha: 1,
                scale: 1,
            });
        },

        hideConfirmDialogue() {
            TweenMax.to(".confirm-overlay", 0.5, {
                autoAlpha: 0,
                ease: Power3.ease,
            });
            TweenMax.to(".confirm-dialogue", 0.5, {
                autoAlpha: 0,
                scale: 1.15,
            });
        },
    }
}
</script>
